module.exports = __webpack_public_path__ + "img/29.571ef310.png";